module.exports = __webpack_public_path__ + "static/media/clients.753eb81d.svg";